// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3vhP5","requiredAsterisk":"Info_requiredAsterisk__w9ebv"};